'use strict';
'use client';
import { j as s } from "../../external/react/jsx-runtime.js";
import d from "../../external/classnames/index.js";
import { useState as u } from "react";
import f from "../Modal/index.js";
import e from "./doctor-card.module.scss.js";
import { FontAwesomeIcon as c } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faUserDoctor as i } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { getFullName as N } from "../../helpers/doctorUtils.js";
import w from "html-react-parser";
const D = ({
  image: r,
  firstName: n,
  lastName: h,
  titleText: x,
  specialisation: l,
  bio: a,
  className: j,
  onOpenBio: m
}) => {
  const [p, t] = u(!1), o = N({ firstName: n, lastName: h, titleText: x });
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: d(e["item-wrapper"], j),
        onClick: () => {
          t(!0), m && m();
        },
        "data-disabled": !a,
        children: [
          /* @__PURE__ */ s.jsxs("div", { className: e.content, children: [
            r ? /* @__PURE__ */ s.jsx("picture", { className: e.image, children: /* @__PURE__ */ s.jsx("img", { src: r, alt: o, sizes: "3rem" }) }) : /* @__PURE__ */ s.jsx(
              c,
              {
                className: e.icon,
                icon: i,
                width: 36,
                height: 32
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: e.details, children: [
              /* @__PURE__ */ s.jsx("h4", { children: o }),
              l ? /* @__PURE__ */ s.jsx("h5", { children: l }) : null
            ] })
          ] }),
          a ? /* @__PURE__ */ s.jsxs("button", { className: e.bio, children: [
            "Read bio",
            /* @__PURE__ */ s.jsx(
              c,
              {
                icon: i,
                width: 16,
                height: 16
              }
            )
          ] }) : null
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      f,
      {
        id: "doctor-bio-modal",
        isOpen: p,
        onModalClose: t,
        className: e.modal,
        children: [
          r ? /* @__PURE__ */ s.jsx("picture", { className: d(e["modal-image"]), children: /* @__PURE__ */ s.jsx(
            "img",
            {
              src: r,
              alt: o,
              sizes: "(max-width: 768px) 100vw, 33vw"
            }
          ) }) : null,
          /* @__PURE__ */ s.jsxs("div", { className: e["modal-content"], children: [
            /* @__PURE__ */ s.jsxs("header", { className: e["modal-header"], children: [
              /* @__PURE__ */ s.jsx("h4", { children: o }),
              l ? /* @__PURE__ */ s.jsx("h5", { children: l }) : null
            ] }),
            a ? w(a) : null
          ] })
        ]
      }
    )
  ] });
};
export {
  D as default
};
